__turbopack_context__.v({
  "button": "SubscribeSection-module-scss-module__JzTSBG__button",
  "buttonText": "SubscribeSection-module-scss-module__JzTSBG__buttonText",
  "description": "SubscribeSection-module-scss-module__JzTSBG__description",
  "disabled": "SubscribeSection-module-scss-module__JzTSBG__disabled",
  "form": "SubscribeSection-module-scss-module__JzTSBG__form",
  "input": "SubscribeSection-module-scss-module__JzTSBG__input",
  "root": "SubscribeSection-module-scss-module__JzTSBG__root",
});
